import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const pageSectionStyles = {
    cardContainer: {
        backgroundColor: colors.core.snow,
        position: 'relative',
    },
    stickyContainer: (topOffset: number) =>
        (({
            position: 'sticky',
            top: `${topOffset}px`,
            zIndex: 300,

            [`@media (max-width: ${breakpoints.md})`]: {
                top: 0,
            },
        }) as const),
    hiddenText: {
        width: '100%',
        bottom: '1rem',
        left: '1rem',
        position: 'absolute',
        transition: 'color 0.25s ease',
        opacity: 0.4,
    },
    overlay: {
        backgroundColor: 'rgba(1, 23, 41, 0.3)',
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'block',
        zIndex: 9,
        '&:hover p': {
            color: colors.core.snow,
            opacity: 1,
        },
    },
    errorNotification: {
        backgroundColor: colors.core.ember,
        position: 'absolute',
        width: '30rem',
        zIndex: 9,
        bottom: '2rem',
        left: '2rem',
        borderRadius: '0.8rem',
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: '1rem',
    },
    warningIcon: {
        width: '5rem',
        height: '5rem',
        marginRight: '1rem',
        '& path': {
            fill: colors.core.snow,
        },
    },
    hideButton: {
        display: 'none',
    },
    showButton: {
        display: 'flex',
    },
} as const;
